/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reporterAndQuestioner.vue?vue&type=template&id=3c5f50f7&scoped=true&"
import script from "./reporterAndQuestioner.vue?vue&type=script&lang=js&"
export * from "./reporterAndQuestioner.vue?vue&type=script&lang=js&"
import style0 from "./reporterAndQuestioner.vue?vue&type=style&index=0&id=3c5f50f7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5f50f7",
  null
  
)

export default component.exports